var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#62A9A9",
    stroke: "none",
    transform: "translate(19 19.171)",
    d: "M0 6L6 6L6 0L0 0L0 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#62A9A9",
    stroke: "none",
    transform: "translate(0.999573 0.999603)",
    d: "M22 4L22 0L26.001 0L26.001 4L32 4L32 32L0 32L0 4L6 4L6 0L10 0L10 4L22 4ZM28 28L4 28L4 11L28 11L28 28Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEnd);
export default __webpack_public_path__ + "static/media/calendar_end.7f93711b98580b6f503006da2b106ccd.svg";
export { ForwardRef as ReactComponent };